import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useStoreFinderContext, Components, Hooks } from '@grandvisionhq/stores-v2';

const { StoreFinderClickableItem , StoreFinderItem  } = Components;
const { useFormattedDistance  } = Hooks;
var StoreFinderItemContainer = (_param)=>{
    var { onClick , variant , store  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "onClick",
        "variant",
        "store"
    ]);
    const { setHoveredStore  } = useStoreFinderContext();
    const distance = useFormattedDistance(store === null || store === void 0 ? void 0 : store.distance);
    const onClickHandler = React.useCallback(()=>{
        store && onClick(store);
    }, [
        store,
        onClick
    ]);
    const onMouseEnterHandler = React.useCallback(()=>{
        store && setHoveredStore(store);
    }, [
        setHoveredStore,
        store
    ]);
    const onMouseLeaveHandler = React.useCallback(()=>{
        setHoveredStore(null);
    }, [
        setHoveredStore
    ]);
    if (!store) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreFinderClickableItem, swcHelpers.extends({}, rest, {
        className: "service-store__list-item",
        onClick: onClickHandler,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler,
        variant: variant
    }), /*#__PURE__*/ React.createElement(StoreFinderItem, {
        addressSize: "MINIMAL",
        showAttributesAs: "icons",
        store: swcHelpers.objectSpread({}, store, {
            wheelchairAccessible: false,
            hearingAppointmentPossible: false,
            isFranchiseStore: false,
            storeNote: undefined
        }),
        distance: distance,
        showEmailAddress: false,
        showPhone: false,
        showOpeningHours: false
    }));
};

export { StoreFinderItemContainer };
//# sourceMappingURL=StoreFinderItemContainer.js.map
